import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import CustomersEntity from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const customersEntityRoute = (
  <ProtectedRoute
    subject={S.CUSTOMERS_ENTITY_PAGE}
    path={P.CUSTOMERS_ENTITY_PAGE}
    component={CustomersEntity}
  />
);
